import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "@biletix/core/services/authentication.service";
import {LoggedInCustomer} from "@biletix/core/models/authentication/logged-in-customer.model";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {MenuItem} from "@biletix/core/view-models/menu-item.model";
import {RouterService} from "@biletix/core/services/router.service";
import {Router} from "@angular/router";
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import {LocalStorageService} from "@biletix/core/services/local-storage.service";

@Component({
    standalone: false,
    selector: 'btx-account-dropdown',
    templateUrl: './account-dropdown.component.html',
    styleUrls: ['./account-dropdown.component.scss']
})
export class AccountDropdownComponent extends AbstractionComponent implements OnInit {

    loggedInCustomer?: LoggedInCustomer;
    menuItems: MenuItem[] = [];
    shoppingCartState: any;

    constructor(private authenticationService: AuthenticationService,
                private ticketSaleService: TicketSaleService,
                private router: Router,
                private localStorageService: LocalStorageService,
                private routerService: RouterService) {
        super();
    }

    ngOnInit(): void {

        //sync logged in user data before checks
        this.loggedInCustomer = this.authenticationService.getLoggedInCustomer();

        //check login
        this.checkLogin();

        //watch login customer
        this.watchLoginUser();

        //
        this.buildAccountDropdownMenu();
    }

    showTimerInHeader(){
        //const isMobile = this.getIsMobile();
        const isExistShoppingCart =this.isExistShoppingCart();
        const isCartPage =this.isCartPage();
        const isOrderSummaryExists =this.isOrderSummaryExists();

        //return !isMobile && isExistShoppingCart && !isCartPage&&!isOrderSummaryExists;
        return isExistShoppingCart && !isCartPage&&!isOrderSummaryExists;

      }

      isOrderSummaryExists(){
        return this.shoppingCartState && this.shoppingCartState.isNotEmpty();
      }

      isCartPage() {
        return this.router.url.indexOf('/cart') > -1;
      }


      isExistShoppingCart(): boolean {
          return this.ticketSaleService.isExistShoppingCart();
      }

    watchLoginUser() {
        this.authenticationService
            .watchLoggedInCustomer
            .pipe(this.takeUntilDestroy())
            .subscribe(loggedInCustomer => this.loggedInCustomer = loggedInCustomer);
    }

    checkLogin() {
        if (this.loggedInCustomer && this.loggedInCustomer.customerId) {
            this.authenticationService
                .checkLogin()
                .pipe(this.takeUntilDestroy())
                .subscribe(isLogin => {
                        if (!isLogin) {
                            this.localStorageService.clear();
                            this.ticketSaleService.clearLocalShoppingCart();
                            this.buildAccountDropdownMenu();
                        }
                    }
                );
        }
    }

    /**
     *
     */
    private buildAccountDropdownMenu() {
        this.menuItems = [
            //Profile menu item
            {
                order: 3, url: this.routerService.accountMyPersonalInformationUrl,
                label: "account.labels.myProfile", icon: 'person_outline'
            },
            //Addresses menu
            {
                order: 4, url: this.routerService.accountMyAddressesUrl,
                label: "shared.labels.myAddresses",
                icon: 'home'
            },
            //My Tickets
            {
                order: 5, url: this.routerService.accountMyTicketsUrl,
                label: "shared.labels.myTickets", icon: 'confirmation_number'
            },
          {
            order: 7, url: this.routerService.fanInfoUrl,
            label: "account.labels.fanInfo", icon: 'confirmation_number'
          },
            // {
            //     order: 6, url: this.routerService.accountFavoritesUrl,
            //     label: "shared.labels.myFavorites", icon: 'favorite_border'
            // }
        ];


        if (!this.isAuthenticated) {
          const returnUrl = this.routerService.getReturnUrl();
            this.menuItems.push({
                order: 1,
                url: this.routerService.loginUrl,
                queryParams : {"returnUrl" : this.routerService.getReturnUrl()},
                label: "auth.labels.signIn",
                icon: "login"
            });
            this.menuItems.push({
                order: 2,
                url: this.routerService.registerUrl,
                label: "auth.labels.createAccount",
                icon: "person_add_alt_1"
            });
        }

        return this.menuItems.sort((item1, item2) => item1.order < item2.order ? -1 : 1)
    }

    public get isAuthenticated(): boolean {
        return this.authenticationService.getLoggedInCustomer() ?? false;
    }

    public doLogout(): void {
        this.authenticationService
            .doLogout()
            .pipe(this.takeUntilDestroy())
            .subscribe(() => {
                    this.buildAccountDropdownMenu();
                    this.authenticationService.clearLogin();
                    this.ticketSaleService.clearLocalShoppingCart();

                    //TODO: Seam devre dışı kalınca aktif edilecek.
                    // this.routerService.navigateToHomePage()
                    this.routerService.navigateToSeamHomePage();
                }
            );
    }

    public get loggedInUserName() {
        let userName = this.loggedInCustomer?.name;
        if (userName && userName.length > 10) {
            return userName.substring(0, 10).concat("...");
        }
        return userName;
    }

}
